import styled, { css } from 'styled-components'

export const ChoosePayment = styled.li`
  display: inline-block;
  margin-right: 15px;
`

export const ChoosePaymentItem = styled.input`
  ${({ checked }) => css`
    color: ${checked ? 'var(--text-primary)' : '#000000'};
    position: absolute;
    visibility: hidden;
    font-weight: bold;

    & + label {
      color: var(--text-tertiary);
      cursor: pointer;
      font-size: var(--font-size-sm);

      padding: 10px 18px;

      ${checked &&
      css`
        border-bottom: solid var(--theme-primary) 4px;
        color: var(--text-primary);
        font-weight: bold;
      `}
    }
  `}
`

export const TabGroup = styled.ul`
  ${({ margin }) => css`
    display: flex;
    list-style: none;
    margin: ${margin ?? 'unset'};
    margin-bottom: 1.5rem;
  `}
`
